import api from './api';

export interface ParametrosPreSuprimentos {
    preSuprimentosDdiDuracao: number
    preSuprimentosDdiValorMinimo: number
    preSuprimentosLimiteInferiorGovernancaAprovacao: number
    preSuprimentosLimiteSuperiorGovernancaAprovacao: number
    preSuprimentosMinimoAnaliseGpc: number
    preSuprimentosAnaliseRiscoPrivacidade: boolean
}

export const GetQaqc = () => api.get<any[]>('configuracoes/QAQC');
export const UpdateQaqc = values => api.put('configuracoes/QAQC', values);

export const GetPreSuprimentos = () => api.get<any>('configuracoes/PreSuprimentos');
export const UpdatePreSuprimentos = values => api.put('configuracoes/PreSuprimentos', values);
export const UpdateAtributoCci = values => api.put('configuracoes/AtributoCci', values);

export interface ParametrosSas {
    sasValorMinimoAprovacaoGerenteGeral: number;
    sasValorConfide: number;
    sasPercentualMargemAprovada: number;
    sasLimiteMaximoVariacao: number;
    sasMinutaSimplificada: number;
    sasValorMinimoRealizacaoRH: number;
    sasValorMaximoGerenteDepartamento: number;
    sasValorMaximoGerenteGeral: number;
    sasValorMaximoGerenteDepartamentoHabilitado: boolean;
    sasValorMaximoGerenteGeralHabilitado: boolean;
}
export const GetSas = () => api.get<ParametrosSas>('configuracoes/Sas');
export const UpdateSas = values => api.put('configuracoes/Sas', values);

export interface ParametrosSubcontratacao {
    subcontratacaoPrazoNotificacao: number;
}

export const GetSubcontratacao = () => api.get<ParametrosSubcontratacao>('configuracoes/Subcontratacao');
export const UpdateSubcontratacao = values => api.put('configuracoes/Subcontratacao', values);


export const GetFaturamentoDireto = () => api.get<ParametrosSubcontratacao>('configuracoes/FaturamentoDireto');
export const UpdateFaturaMentoDireto = values => api.put('configuracoes/FaturamentoDireto', values);